// Shared badge rendering for payment gateway log rows. Types and status
// codes come from the API (PaymentLogsController / PaymentLogStatusClassifier)
// — keep these maps in sync with the backend vocabularies.

interface BadgeI {
  label: string;
  classes: string;
}

// A single transaction produces several rows: a "Setup" row when the checkout
// is created at the gateway, a "Payment" row when the outcome is recorded, and
// "Webhook" rows for server-to-server notifications — so the same reference
// appears once per stage, not as duplicates.
export const typeBadge = (type: string): BadgeI => {
  switch (type) {
    case 'init':
      return { label: 'Setup', classes: 'bg-gray-100 text-gray-700' };
    case 'payment':
      return { label: 'Payment', classes: 'bg-blue-100 text-blue-700' };
    case 'webhook':
      return { label: 'Webhook', classes: 'bg-purple-100 text-purple-700' };
    case 'credential-check':
      return { label: 'Credential check', classes: 'bg-teal-100 text-teal-700' };
    default:
      return { label: type || '-', classes: 'bg-gray-100 text-gray-700' };
  }
};

export const statusBadge = (statusCode: string): BadgeI => {
  switch (statusCode) {
    case 'created':
      return { label: 'Created', classes: 'bg-gray-100 text-gray-700' };
    case 'pending':
      return { label: 'Pending', classes: 'bg-amber-100 text-amber-800' };
    case 'success':
      return { label: 'Success', classes: 'bg-green-100 text-green-800' };
    case 'failed':
      return { label: 'Failed', classes: 'bg-red-100 text-red-800' };
    case 'cancelled':
      return { label: 'Cancelled', classes: 'bg-orange-100 text-orange-800' };
    case 'error':
      return { label: 'Error', classes: 'bg-rose-100 text-rose-800' };
    default:
      return { label: statusCode || 'Other', classes: 'bg-gray-100 text-gray-500' };
  }
};
